import { useContext, useMemo } from 'react'
import { buildPanelCheckItems } from 'components/Cruises/SearchPage/Filters/Inputs/buildPanelCheckItems'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

import { trackEvent } from 'analytics/analytics'
import { mapCruiseLineFilterToSnowplowSearchEvent } from 'analytics/mapSnowplowSearchTracking'
import { searchEventWithContext } from 'analytics/snowplow/events'
import { CRUISE_TRAVELLER_TYPE_FILTER_FACETS } from 'constants/cruise'
import useCruiseTravellerTypeLabel from 'hooks/Cruise/useCruiseTravellerTypeLabel'

interface Props {
  travellerTypes?: Set<string>
  onChange: (value: any) => void
}

function CruiseTravellerTypeFilter({
  travellerTypes,
  onChange,
}: Props) {
  const globalSearchState = useContext(GlobalSearchStateContext)
  const formatTravellerTypeLabel = useCruiseTravellerTypeLabel()

  const travellerTypeItems = useMemo(() => {
    return buildPanelCheckItems(CRUISE_TRAVELLER_TYPE_FILTER_FACETS.map(facet => ({
      ...facet,
      label: formatTravellerTypeLabel(facet.slug) ?? facet.slug,
    })))
  }, [formatTravellerTypeLabel])

  return <div data-testid="cruise-traveller-type-filter">
    <FilterPanelCheckboxGroup
      name="travellerTypes"
      items={travellerTypeItems}
      onChange={(e) => {
        trackEvent(searchEventWithContext({
          searchEvent: { type: 'filters' },
          sortContext: { value: 'recommended' },
          searchContext: mapCruiseLineFilterToSnowplowSearchEvent(globalSearchState),
          filterContexts: [{
            label: e.target.value,
            type: 'traveller_type',
            value: e.target.checked ? 'selected' : 'unselected',
          }],
        }))

        onChange(e)
      }}
      defaultSelected={travellerTypes}
    />
  </div>
}

export default CruiseTravellerTypeFilter
